export const getDefaultJsonSchemaAiNodeBE = () => ({
  $schema: "http://json-schema.org/draft-07/schema#",
  type: "object",
  properties: {},
  required: [],
  order: [],
});
